import React, { useState, useRef, useEffect } from "react"
import { twMerge } from "tailwind-merge"
import PopNav from "./popnav"
import Transition from "../transition"
import { ChevronDownIcon } from "@heroicons/react/20/solid"
import { XMarkIcon } from "@heroicons/react/20/solid"

const ProductNavButton = () => {
  const [productsOpen, setProductsOpen] = useState(false)

  const node = useRef()
  useEffect(() => {
    const handleClickOutside = e => {
      if (node.current.contains(e.target)) {
        return
      }
      setProductsOpen(!productsOpen)
    }
    if (productsOpen) {
      document.addEventListener("mousedown", handleClickOutside)
    } else {
      document.removeEventListener("mousedown", handleClickOutside)
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [productsOpen])

  return (
    <div ref={node} className="hidden lg:ml-6 lg:flex">
      {/* <!-- Item active: "text-slate-900", Item inactive: "text-slate-500" --> */}
      <ProductButton
        type="button"
        onClick={() => setProductsOpen(!productsOpen)}
      >
        <span>Products</span>
        {productsOpen ? (
          <XMarkIcon className="ml-1group-hover:text-slate-500 h-5 w-5 text-slate-400 transition duration-150 ease-in-out group-focus:text-slate-500" />
        ) : (
          <ChevronDownIcon className="ml-1group-hover:text-slate-500 h-5 w-5 text-slate-400 transition duration-150 ease-in-out group-focus:text-slate-500" />
        )}
      </ProductButton>

      <Transition
        show={productsOpen}
        enter="transition ease-out duration-100"
        enterFrom="opacity-0 translate-y-1"
        enterTo="opacity-100 translate-y-0"
        leave="transition ease-in duration-150"
        leaveFrom="opacity-100 translate-y-0"
        leaveTo="opacity-0 translate-y-1"
      >
        <div className="absolute mt-20 w-screen max-w-md px-2 sm:px-0 lg:left-0 lg:max-w-5xl xl:left-1/2 xl:-translate-x-1/2 xl:transform">
          <div className="rounded-lg shadow-lg">
            <div className="overflow-hidden rounded-lg ring-1 ring-black ring-opacity-5">
              <div className="relative z-20 grid gap-6 bg-white px-5 py-6 sm:gap-8 sm:p-8 lg:grid-cols-2">
                <PopNav></PopNav>
              </div>
              {/* <div className="p-5 bg-slate-50 sm:p-8">
                        <Link
                          to="/fp"
                          className="-m-3 p-3 flow-root space-y-1 rounded-md hover:bg-slate-100 transition ease-in-out duration-150"
                        >
                          <div className="flex items-center space-x-3">
                            <div className="text-base leading-6 font-medium text-slate-900">
                              In the Fight against COVID-19
                            </div>
                            <span className="inline-flex items-center px-3 py-0.5 rounded-full text-xs font-medium leading-5 bg-rose-200 text-rose-800">
                              NEW Product Name
                            </span>
                          </div>
                          <p className="text-sm leading-tight text-slate-400 max-w-md lg:max-w-xl">
                            Searching for products that can help your COVID-19
                            research programs? Click here to see Thomson's
                            featured products!
                          </p>
                        </Link>
                      </div> */}
            </div>
          </div>
        </div>
      </Transition>
    </div>
  )
}
const ProductButton = props => {
  return (
    <button
      type={props.type}
      onClick={props.onClick}
      className={twMerge([
        "ml-8 inline-flex items-center border-b-2 border-transparent px-1 pt-1 text-sm font-medium leading-5 text-slate-500 transition first-of-type:ml-0 hover:border-blue-500 hover:text-slate-700 focus:outline-none",
        props.className,
      ])}
    >
      {props.children}
    </button>
  )
}

export default ProductNavButton
